import React, { useState } from "react";
import { X, Plus, Check } from "lucide-react";

const serviceOptions = {
    categories: [
        { id: "digital-print", label: "Digital Print" },
        { id: "offset-print", label: "Offset Print" },
        { id: "large-format", label: "Large Format" },
        { id: "screen-print", label: "Screen Print" },
        { id: "3d-print", label: "3D Print" },

        { id: "business-cards", label: "Business Cards" },
        { id: "flyers-brochures", label: "Flyers & Brochures" },
        { id: "booklets", label: "Booklets" },
        { id: "banners-posters", label: "Banners & Posters" },

        { id: "vinyl-stickers", label: "Vinyl & Stickers" },
        { id: "vehicle-wraps", label: "Vehicle Wraps" },
        { id: "signage", label: "Signage" },
        { id: "photo-printing", label: "Photo Printing" },

        { id: "canvas-prints", label: "Canvas Prints" },
        { id: "art-prints", label: "Art Prints" },
        { id: "binding-finishing", label: "Binding & Finishing" },
        { id: "lamination", label: "Lamination" },

        { id: "embossing", label: "Embossing" },
        { id: "foil-stamping", label: "Foil Stamping" },
        { id: "packaging", label: "Packaging" },
        { id: "labels", label: "Labels" },
        { id: "tshirt-printing", label: "T-Shirt Printing" },

        { id: "promotional-items", label: "Promotional Items" },
        { id: "stationery", label: "Stationery" },
        { id: "paper-cardstock", label: "Paper & Cardstock" },
        { id: "printer-toner-ink", label: "Printer Toner & Ink" },

        { id: "printing-equipment", label: "Printing Equipment" },
        { id: "binding-supplies", label: "Binding Supplies" },
        { id: "laminating-film", label: "Laminating Film" },
        { id: "vinyl-rolls", label: "Vinyl Rolls" },

        { id: "banner-material", label: "Banner Material" },
        { id: "sublimation-paper", label: "Sublimation Paper" },
        { id: "heat-transfer-vinyl", label: "Heat Transfer Vinyl" },

        { id: "screen-printing-supplies", label: "Screen Printing Supplies" },
        { id: "cutting-blades", label: "Cutting Blades" },
        { id: "adhesives-glues", label: "Adhesives & Glues" },
    ],
};

const supplyOptions = {
    categories: [
        { id: "printing-machines", label: "Printing Machines" },
        { id: "signage-supplies", label: "Signage Supplies" },
        { id: "display-supplies", label: "Display Supplies" },
        { id: "sublimation-supplies", label: "Sublimation Supplies" },
        { id: "wide-format-supplies", label: "Wide Format Supplies" },
        { id: "finishing-equipment", label: "Finishing Equipment" },
        { id: "paper-cardstock", label: "Paper & Cardstock" },
        { id: "printer-toner-ink", label: "Printer Toner & Ink" },
        { id: "printing-equipment", label: "Printing Equipment" },
        { id: "binding-supplies", label: "Binding Supplies" },
        { id: "laminating-film", label: "Laminating Film" },
        { id: "vinyl-rolls", label: "Vinyl Rolls" },
        { id: "banner-material", label: "Banner Material" },
        { id: "sublimation-paper", label: "Sublimation Paper" },
        { id: "heat-transfer-vinyl", label: "Heat Transfer Vinyl" },
        { id: "screen-printing-supplies", label: "Screen Printing Supplies" },
        { id: "cutting-blades", label: "Cutting Blades" },
        { id: "adhesives-glues", label: "Adhesives & Glues" },
        { id: "textile-garment-supplies", label: "Textile & Garment Supplies" },
        { id: "uv-printing-supplies", label: "UV Printing Supplies" },
        { id: "dtf-supplies", label: "DTF Supplies" },
        { id: "packaging-materials", label: "Packaging Materials" },
        { id: "mounting-framing", label: "Mounting & Framing" },
    ],

    inkCompatibility: {
        title: "Ink Compatibility",
        description:
            "Are your supplies approved for any of these ink types? Select all that apply, or skip.",

        options: [
            {
                id: "solvent",
                title: "Solvent",
                desc: "For outdoor & industrial applications - durable and weather-resistant",
            },
            {
                id: "eco-solvent",
                title: "Eco-Solvent",
                desc: "For indoor signage & vehicle wraps - low odour, vibrant colours",
            },
            {
                id: "latex",
                title: "Latex",
                desc: "For high-volume production - fast drying, scratch-resistant",
            },
        ],
    },

    customInput: {
        title: "Add a custom item",
        placeholder: "e.g. DTF Film, Eco-Solvent Ink…",
    },
};

const WhatDoYouOffer = ({ form, setForm, selectedPlan }) => {
    const [customInput, setCustomInput] = useState("");
    const [searchSupplies, setSearchSupplies] = useState("");
    const isSupplierShop = selectedPlan.key === "supplier";

    let showSuppliesOption;

    if (isSupplierShop) {
        showSuppliesOption = supplyOptions.categories;
    } else {
        showSuppliesOption = serviceOptions.categories;
    }

    // SAFE DEFAULTS
    const selectedSupplies = form.selectedSupplies || [];
    const customSupplies = form.customSupplies || [];
    const inkTypes = form.inkTypes || [];

    const selectedCount = selectedSupplies.length + customSupplies.length;

    // TOGGLE CATEGORY
    const toggleSupply = (item) => {
        setForm((prev) => {
            const list = prev.selectedSupplies || [];
            const exists = list.includes(item);

            return {
                ...prev,
                selectedSupplies: exists
                    ? list.filter((i) => i !== item)
                    : [...list, item],
            };
        });
    };

    // TOGGLE INK
    const toggleInk = (id) => {
        setForm((prev) => {
            const list = prev.inkTypes || [];
            const exists = list.includes(id);

            return {
                ...prev,
                inkTypes: exists
                    ? list.filter((i) => i !== id)
                    : [...list, id],
            };
        });
    };

    // ADD CUSTOM TAG
    const addCustomTag = () => {
        if (!customInput.trim()) return;

        setForm((prev) => ({
            ...prev,
            customSupplies: [...(prev.customSupplies || []), customInput.trim()],
        }));

        setCustomInput("");
    };

    // REMOVE SUPPLY TAG
    const removeSupply = (item) => {
        setForm((prev) => ({
            ...prev,
            selectedSupplies: (prev.selectedSupplies || []).filter(
                (i) => i !== item
            ),
        }));
    };

    // REMOVE CUSTOM TAG
    const removeCustomTag = (tag) => {
        setForm((prev) => ({
            ...prev,
            customSupplies: (prev.customSupplies || []).filter(
                (t) => t !== tag
            ),
        }));
    };

    return (
        <>
            {/* COUNT */}
            {selectedCount > 0 && (
                <div className="flex items-center gap-[8px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-tag w-[16px] h-[16px] text-[#ff5323]"
                    >
                        <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
                        <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
                    </svg>

                    <span className="font-semibold text-[14px] text-[#212326]">
                        {selectedCount} items selected
                    </span>
                </div>
            )}

            {/* SELECTED SUPPLIES TAGS */}
            <div className="flex flex-wrap gap-[8px]">
                {selectedSupplies.map((item) => (
                    <button
                        key={item}
                        onClick={() => removeSupply(item)}
                        className="flex items-center gap-[6px] px-[12px] py-[6px] rounded-full text-white font-semibold text-[13px] transition-all bg-[#ff5323] hover:bg-[#e64a1f]"
                    >
                        {item}
                        <X className="w-[12px] h-[12px]" />
                    </button>
                ))}

                {/* CUSTOM TAGS */}
                {customSupplies.map((tag) => (
                    <button
                        key={tag}
                        onClick={() => removeCustomTag(tag)}
                        className="flex items-center gap-[6px] px-[12px] py-[6px] rounded-full text-white font-semibold text-[13px] transition-all bg-[#ff5323] hover:bg-[#e64a1f]"
                    >
                        {tag}
                        <X className="w-[12px] h-[12px]" />
                    </button>
                ))}
            </div>

            {/* SUPPLY OPTIONS */}
            <div className="bg-white rounded-[16px] border border-[#e4e5e7] p-[24px] md:p-[32px] flex flex-col gap-[20px]">
                <input
                    value={searchSupplies}
                    onChange={(e) => setSearchSupplies(e.target.value)}
                    placeholder={isSupplierShop ? "Search supplies..." : "Search services..."}
                    className="w-full h-[44px] rounded-[10px] border border-[#e4e5e7] px-[14px] font-medium text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                />
                <div className="flex flex-wrap gap-[8px]">
                    {showSuppliesOption.map((cat) => {
                        const active = selectedSupplies.includes(cat.label);

                        return (
                            <button
                                key={cat.id}
                                onClick={() => toggleSupply(cat.label)}
                                className={`px-[14px] py-[8px] rounded-[10px] text-[13px] border transition-all font-semibold ${active
                                    ? "border-[#ff5323] bg-[#fff5f2] text-[#ff5323]"
                                    : "border-[#e4e5e7] text-[#212326] bg-white"
                                    }`}
                            >
                                {cat.label}
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* CUSTOM INPUT */}
            <div className="bg-white rounded-[16px] border p-[24px] flex flex-col gap-[12px]">
                <p className="font-semibold text-[14px]">
                    {supplyOptions.customInput.title}
                </p>

                <div className="flex gap-[10px]">
                    <input
                        value={customInput}
                        onChange={(e) => setCustomInput(e.target.value)}
                        placeholder={supplyOptions.customInput.placeholder}
                        className="flex-1 h-[44px] rounded-[10px] border border-[#e4e5e7] px-[14px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                    />

                    <button
                        onClick={addCustomTag}
                        disabled={!customInput.trim()}
                        className="flex items-center gap-[6px] px-[16px] h-[44px] rounded-[10px] font-semibold text-[13px] bg-[#212326] text-white hover:bg-[#3a3c40 text-white disabled:bg-[#e4e5e7]"
                    >
                        <Plus className="w-[14px] h-[14px]" />
                        Add
                    </button>
                </div>

                {customSupplies.length > 0 && (
                    <div className="flex flex-col gap-[8px] mt-[4px]">
                        <p className="font-medium text-[12px] text-[#9298a0] uppercase tracking-[0.5px]">
                            Custom tags
                        </p>
                        <div className="flex flex-wrap gap-[8px]">
                            {/* CUSTOM TAGS */}
                            {customSupplies.map((tag) => (
                                <button
                                    key={tag}
                                    onClick={() => removeCustomTag(tag)}
                                    className="flex items-center gap-[6px] px-[12px] py-[6px] rounded-[8px] bg-[#f0f1f3] text-[#212326] font-medium text-[13px] hover:bg-[#e4e5e7] transition-colors"
                                >
                                    {tag}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x w-[12px] h-[12px] text-[#9298a0]">
                                        <path d="M18 6 6 18">
                                        </path>
                                        <path d="m6 6 12 12">
                                        </path>
                                    </svg>
                                </button>
                            ))}

                        </div>
                    </div>
                )}

            </div>

            {/* INK COMPATIBILITY */}
            <div className="bg-white rounded-[16px] border p-[24px] flex flex-col gap-[16px]">

                <div className="flex items-center gap-[10px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] bg-[#f0f4ff] flex items-center justify-center shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-droplets w-[18px] h-[18px] text-[#4a6cf7]">
                            <path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"></path>
                            <path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"></path>
                        </svg>
                    </div>
                    <div>
                        <p className="font-semibold text-[15px] text-[#212326]">{supplyOptions.inkCompatibility.title}</p>
                        <p className="font-semibold text-[13px] text-[#717182] leading-[1.5]">
                            {supplyOptions.inkCompatibility.description}
                        </p>
                    </div>
                </div>

                <div className="flex flex-col gap-[10px]">
                    {supplyOptions.inkCompatibility.options.map((opt) => {
                        const active = inkTypes.includes(opt.id);

                        return (
                            <label
                                key={opt.id}
                                className={`flex items-center gap-[14px] p-[14px] rounded-[12px] border-2 cursor-pointer transition-all ${active
                                    ? "border-[#4a6cf7] bg-[#f5f7ff]"
                                    : "border-[#e4e5e7] bg-white"
                                    }`}
                            >
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    checked={active}
                                    onChange={() => toggleInk(opt.id)}
                                />

                                <div
                                    className={`w-[22px] h-[22px] rounded-[6px] border-2 flex items-center justify-center ${active
                                        ? "bg-[#4a6cf7] border-[#4a6cf7]"
                                        : "border-[#d0d2d6]"
                                        }`}
                                >
                                    {active && (
                                        <Check className="w-[12px] h-[12px] text-white" />
                                    )}
                                </div>

                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326]">
                                        {opt.title}
                                    </p>
                                    <p className="font-semibold text-[12px] text-[#9298a0]">
                                        {opt.desc}
                                    </p>
                                </div>
                            </label>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default WhatDoYouOffer;
